import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { ErrorDetails } from 'types/types'
import { ErrorItem } from './ErrorItem'

interface ErrorDisplayProps {
  errorDetails: ErrorDetails
  displaySubTitle?: boolean
}

export const DisplayErrorMessage = ({
  errorDetails = {},
  displaySubTitle = false,
}: ErrorDisplayProps) => {
  const { t } = useTranslation()

  if (Object?.keys(errorDetails)?.length === 0) {
    return null
  }

  const errorMessage =
    Object?.keys(errorDetails)?.length > 1 ? t('errorMultiple') : t('errorSingle')

  const errorKeys = Object?.keys(errorDetails)

  return (
    <Box>
      <span className="text-body-regular text-inherit">{errorMessage}</span>
      <Box paddingT={12}>
        {errorKeys?.map(key => {
          const errors = errorDetails?.[key]

          return (
            !!errors?.length && (
              <ErrorItem
                key={key}
                subTitle={key}
                errors={errors}
                displaySubTitle={displaySubTitle}
              />
            )
          )
        })}
      </Box>
    </Box>
  )
}
